module.exports = __webpack_public_path__ + "img/5.d206248b.jpg";